import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const About: React.FC = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <>
      {/* Focus Section */}
      <section className="section-padding bg-primary-600 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600 via-primary-700 to-blue-600" />
        
        <div ref={ref} className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading mb-6">
              Nosso foco são as <span className="text-blue-200">pessoas.</span>
            </h2>
            <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed">
              A FaliFe Tecnologia e Inovação sabe que cada pessoa deixa um traço único no mundo 
              e trabalha para que, cada vez mais, as nossas soluções também deixem.
            </p>
          </motion.div>
        </div>

        {/* Diagonal Shape */}
        <div className="absolute bottom-0 left-0 right-0 h-24">
          <svg className="w-full h-full" viewBox="0 0 1920 167.98" preserveAspectRatio="none">
            <polygon 
              points="1920 167.98 0 167.98 0 0 1920 167.98" 
              className="fill-white"
            />
          </svg>
        </div>
      </section>

      {/* History Section */}
      <section id="about" className="section-padding">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-center"
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-primary-600 mb-8">
              Nossa História
            </h2>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg text-secondary-600 leading-relaxed">
                Somos uma empresa de consultoria especializada em negócios, processos e tecnologia. 
                Apoiamos bancos, seguradoras, instituições de ensino, utilities e outras empresas 
                líderes em seus setores na transformação digital de seus negócios.
              </p>
              <p className="text-lg text-secondary-600 leading-relaxed mt-6">
                Há mais de 10 anos, nosso time altamente qualificado oferece atendimento ágil, 
                soluções inteligentes e personalizadas, assegurando resultados eficientes alinhados 
                aos desafios da sua empresa.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Simplify Tasks Section */}
      <section className="section-padding bg-secondary-800 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-secondary-800 via-secondary-900 to-gray-900" />
        
        <div className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-center"
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading mb-6">
              Estamos aqui para simplificar <span className="text-primary-400">tarefas.</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Agradar aos olhos sem distrair a mente. A nossa equipe de design UX foca na 
              usabilidade sem perder a estética do produto.
            </p>
          </motion.div>
        </div>

        {/* Diagonal Shape */}
        <div className="absolute bottom-0 left-0 right-0 h-24">
          <svg className="w-full h-full" viewBox="0 0 1920 167.98" preserveAspectRatio="none">
            <polygon 
              points="1920 167.98 0 167.98 0 0 1920 167.98" 
              className="fill-white"
            />
          </svg>
        </div>
      </section>
    </>
  );
};

export default About;
